import { RouteConfig } from "vue-router";

export const groups: RouteConfig[] = [
  {
    // グループ管理
    path: "groups",
    component: () => import("@/pages/Groups/_Tab.vue"),
    children: [
      {
        path: "",
        name: "groups-list",
        component: () => import("@/pages/Groups/GroupsList.vue")
      },
      {
        path: "new",
        name: "groups-new",
        component: () => import("@/pages/Groups/GroupsNew.vue")
      }
    ]
  },
  {
    // グループ詳細
    path: "groups/:groupId",
    component: () => import("@/pages/Group/_Tab.vue"),
    children: [
      {
        path: "",
        name: "group-details",
        component: () => import("@/pages/Group/GroupDetails.vue")
      },
      {
        path: "users",
        name: "group-users",
        component: () => import("@/pages/Group/GroupUsers.vue")
      },
      {
        path: "users/new",
        name: "group-newusers",
        component: () => import("@/pages/Group/UsersNew.vue")
      }
    ]
  },

  {
    // ユーザー詳細 (グループ)
    path: "groups/:groupId/users/:userId",
    component: () => import("@/pages/GroupUser/_Tab.vue"),
    children: [
      {
        path: "",
        name: "group-user-details",
        component: () => import("@/pages/User/UserDetails.vue")
      }
    ]
  }
];
